import "core-js/modules/es.array.reduce.js";
import UserWorksApi from '@/frontend/api/userWorks';
import WorksApi from '@/frontend/api/works';
import setMetas from '@/frontend/functions/setMetas';
import WorkCardComponent from '@/frontend/components/WorkCardComponent';
export default {
  name: "UserWorkPage",
  components: {
    WorkCardComponent
  },

  data() {
    return {
      Work: {},
      Works: [],
      fullDesc: false,
      moreBlock: false,
      descSymbolMax: 530
    };
  },

  computed: {
    description() {
      if (!this.Work.description) return [''];
      if (this.fullDesc) return this.Work.description.split('\r\n');
      return this.Work.description.length > this.descSymbolMax ? this.Work.description.slice(0, this.descSymbolMax).split('\r\n') : this.Work.description.split('\r\n');
    },

    previewList() {
      return [this.Work.imageWithPath];
    }

  },
  watch: {
    $route() {
      this.$route.name === 'user-work' && this.init();
    }

  },

  created() {
    setMetas('user-work');
    this.init();
  },

  methods: {
    openImageViewer(index = 0) {
      this.initialIndexViewer = index;
      this.$refs.triggerPreview && this.$refs.triggerPreview.$el.children[0].click();
    },

    init() {
      UserWorksApi.get({}, this.$route.params.id).then(response => {
        this.Work = response;
        this.moreBlock = this.Work.description && this.Work.description.length > this.descSymbolMax;
        WorksApi.getRand({
          'per-page': 3,
          'expand': ['author'].join(',')
        }).then(response => {
          this.Works = response.items;
          this.Works.forEach(value => {
            value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Цена' ? next.name + ': ' + next.value : old, '');
          });
        });
      }).catch(() => this.$router.push({
        name: 'not-found'
      }));
    }

  }
};